import { render, staticRenderFns } from "./giftsList.vue?vue&type=template&id=4fcbef48&scoped=true&"
import script from "./giftsList.vue?vue&type=script&lang=js&"
export * from "./giftsList.vue?vue&type=script&lang=js&"
import style0 from "./giftsList.vue?vue&type=style&index=0&id=4fcbef48&lang=scss&scoped=true&"
import style1 from "./giftsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbef48",
  null
  
)

export default component.exports